module.exports = __webpack_public_path__ + "img/heroimage.10255c69.png";